import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="mx-auto flex min-h-[60vh] w-full max-w-[1280px] flex-col items-center justify-center px-4 py-20 text-center md:px-8">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-primary-100 text-primary-700">
        <i className="ri-emotion-sad-line text-3xl"></i>
      </span>
      <h1 className="mt-6 text-2xl font-bold text-foreground-950 md:text-3xl">页面走丢了</h1>
      <p className="mt-3 text-sm text-foreground-600">
        没有找到与 <span className="font-mono text-foreground-800">{location.pathname}</span> 匹配的内容
      </p>
      <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
        >
          返回首页
        </Link>
        <Link
          to="/category/movie"
          className="cursor-pointer whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
        >
          浏览电影
        </Link>
      </div>
    </div>
  );
}